export const roomSizeTypesConstants = {
    GET_ROOM_SIZE_TYPES_PENDING  : 'GET_ROOM_SIZE_TYPES_PENDING',
    GET_ROOM_SIZE_TYPES_FULFILLED: 'GET_ROOM_SIZE_TYPES_FULFILLED',
    GET_ROOM_SIZE_TYPES_REJECTED : 'GET_ROOM_SIZE_TYPES_REJECTED',
}